module.exports = __webpack_public_path__ + "img/sun_logo@2x.2ec3c70c.png";